(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'pagosOnlineEnable'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService, pagosOnlineEnable) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        const ESTADO_PENDIENTE = 1;
        const ESTADO_CONFIRMADO = 2;
        const ESTADO_RECHAZADO = 3;
        const ESTADO_PAGADO = 4;

        const GRUPO_INSCRIPTORES = 3;

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();

        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosInscripciones.guardar === true,
            puedeModificar: permisosInscripciones.modificar === true,
            puedeEliminar: permisosInscripciones.eliminar === true,
            esOrganizador: UserInfoService.esOrganizador(),
            esPagoPendiente(estadoId){
                return estadoId == ESTADO_PENDIENTE;
            },
            esEstadoConfirmado(estadoId){
                return estadoId == ESTADO_CONFIRMADO;
            },
            esEstadoRechazado(estadoId){
                return estadoId == ESTADO_RECHAZADO;
            }
        };

        vm.criteriosBusqueda = {
            eventoId: 0,
            estado: ESTADO_PAGADO,
            usuarioId: 0,
            inscriptorId: 0,
            categoriaId: 0,
            nombre: '',
            apellidos: '',
            apellido2: ''
        };

        vm.collection = [];
        vm.estados = [];
        vm.eventos = [];
        vm.inscriptores = [];

        vm.title = 'Inscripciones';

        getComboData(vm.estados, 'api/InscripcionEstados', null, 'Error al cargar los estados')
        .then(function(){
            vm.criteriosBusqueda.estado = ESTADO_PAGADO;
        });
        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');
        getComboData(vm.inscriptores, 'api/Usuarios/ByGrupo', [GRUPO_INSCRIPTORES], 'Error al cargar los inscriptores');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        vm.goToEdit = function(data){
            
            var path = '/editar-inscripcion/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.confirmarPago = function(data){
            
            var path = '';

            if(pagosOnlineEnable) {
                path = '/editar-pago-v2/' + data.id;
            }
            else {
                path = '/editar-pago/' + data.id;
            }

            $location.path(path); 
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.getMonedaSymbol = function(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        };

        function getRemoteController()
        {
            return 'api/Inscripciones/All';
        };

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                eventoId: 0,
                estado: 0,
                usuarioId: 0,
                inscriptorId: 0,
                categoriaId: 0,
                nombre: '',
                apellidos: '',
                apellido2: ''
            };
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();

            const criterios = [
                vm.criteriosBusqueda.eventoId,
                vm.criteriosBusqueda.estado,
                vm.criteriosBusqueda.inscriptorId,
                vm.criteriosBusqueda.categoriaId,
                vm.criteriosBusqueda.nombre === '' ? '0' : vm.criteriosBusqueda.nombre,
                vm.criteriosBusqueda.apellidos === '' ? '0' : vm.criteriosBusqueda.apellidos,
                vm.criteriosBusqueda.apellido2 === '' ? '0' : vm.criteriosBusqueda.apellido2
            ];

            var promise = ApiBaseService.getAll(criterios);

            promise
            .then(function(collection){

                collection.forEach((c)=>{
                    c.verDetalle =  false;
                });

                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Inscripciones';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.confirmar = function(item)
        {
            const data = {
                id: item.id,
                eventoId: item.eventoId,
                estado: ESTADO_CONFIRMADO
            };

            vm.cambiarEstado(data);
        };

        vm.rechazar = function(item)
        {
            const data = {
                id: item.id,
                eventoId: item.eventoId,
                estado: ESTADO_RECHAZADO
            };

            vm.cambiarEstado(data);
        };

        vm.cambiarEstado = function(data){
            ApiBaseService.remoteController = 'api/Inscripciones/Confirmar';
            var promise = ApiBaseService.update(data);
            
            promise
            .then(function(response){
                vm.collection.forEach(function(element) {
                    if(element.id === data.id)
                    {
                        element.estado = response.data.object.estado; 
                        element.estadoDescripcion = response.data.object.estadoDescripcion;                      
                    }
                });
                logger.success('Registro modificado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();